export default {
  LOGIN_URI: 'login',
  HEALTHCHECK_URI: 'health'
}
